// extracted by mini-css-extract-plugin
export default {"imgWrapper":"user_profile_img__imgWrapper--8V3y","img":"user_profile_img__img--oEGG","imgDefault":"user_profile_img__imgDefault--dfGD"};